import p from "./_freeGlobal.js";
var t = typeof exports == "object" && exports && !exports.nodeType && exports, e = t && typeof module == "object" && module && !module.nodeType && module, u = e && e.exports === t, r = u && p.process, d = function() {
  try {
    var o = e && e.require && e.require("util").types;
    return o || r && r.binding && r.binding("util");
  } catch (i) {
  }
}();
const n = d;
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_nodeUtil.js
// module id = 467
// module chunks = 67